import { formatMoney } from "@utils";
import { formatUnits } from "viem";
import { useFetchLpAPR } from "./useFetchLpAPR";

const decimals = 0;

export const useFetchChiEthLpDetailedAPR = () => {
  const { apr: aprData, isFetchedAPR } = useFetchLpAPR();

  const result: bigint[] | undefined = aprData as unknown as
    | bigint[]
    | undefined;

  const totalAprOriginal = result ? result[7] : undefined;
  const chiAprOriginal = result ? result[6] : undefined;
  const stEthAprOriginal = result ? result[4] : undefined;
  const weEthAprOriginal = result ? result[5] : undefined;

  const totalAprFormatted = formatUnits(totalAprOriginal || 0n, decimals);
  const chiAprFormatted = formatUnits(chiAprOriginal || 0n, decimals);
  const stEthAprFormatted = formatUnits(stEthAprOriginal || 0n, decimals);
  const weEthAprFormatted = formatUnits(weEthAprOriginal || 0n, decimals);

  const formatAprForDisplay = (aprValue: string) =>
    formatMoney(Number(aprValue || 0));

  // Constructing the detailed APR and displayable data
  const detailedApr = {
    totalApr: {
      original: totalAprOriginal,
      formatted: formatAprForDisplay(totalAprFormatted),
    },
    chiApr: {
      original: chiAprOriginal,
      formatted: formatAprForDisplay(chiAprFormatted),
    },
    stEthApr: {
      original: stEthAprOriginal,
      formatted: formatAprForDisplay(stEthAprFormatted),
    },
    weEthApr: {
      original: weEthAprOriginal,
      formatted: formatAprForDisplay(weEthAprFormatted),
    },
  };

  // Preparing displayable data
  const aprDisplayable = {
    totalApr: {
      value: detailedApr.totalApr.formatted,
      isFetched: isFetchedAPR,
      label: "Total APR",
    },
    chiApr: {
      value: detailedApr.chiApr.formatted,
      isFetched: isFetchedAPR,
      label: "CHI APR",
    },
    stEthApr: {
      value: detailedApr.stEthApr.formatted,
      isFetched: isFetchedAPR,
      label: "stCHI APR",
    },
    weEthApr: {
      value: detailedApr.weEthApr.formatted,
      isFetched: isFetchedAPR,
      label: "weETH APR",
    },
  };

  return {
    aprDisplayable,
    detailedApr,
    isFetchedAPR,
  };
};
